import { render, staticRenderFns } from "./fixedTools.vue?vue&type=template&id=52c131f4&scoped=true&"
import script from "./fixedTools.vue?vue&type=script&lang=js&"
export * from "./fixedTools.vue?vue&type=script&lang=js&"
import style0 from "./fixedTools.vue?vue&type=style&index=0&id=52c131f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c131f4",
  null
  
)

export default component.exports